import { render } from "./GetRequest.vue?vue&type=template&id=00c63329"
import script from "./GetRequest.vue?vue&type=script&lang=js"
export * from "./GetRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__